module.exports = __webpack_public_path__ + "img/13.f21b2408.png";